import { writable } from "svelte/store";

const defaults = {
    boardType: null,
    productName: '',
    productNameColor: null,
    background: null,
    foreground: null,
    border: 'none',
    borderDisplay: false,
    iconTheme: 'light',
    iconSet: 'default',
    iconNav: 'none',
    iconUpDown: 'none',
    ledText: false,
    logoDimension: 'medium',
    logoPosition: null,
    logoMeccalte: true,
    logo: null
};

const settings = writable({ ...defaults });

export { settings, defaults };